import React from 'react';

import "../SCSS/Loading.scss";

const Loading = () => {
    return (
        <div className="Loading">
            Loading.....
        </div>
    )
}

export default Loading;